// Access points on each house photo: x/y in % of the image.
const AP = (id, x, y, model, band, speed, devices, m) => ({ id, x, y, model, band, speed, devices, m });

export const SCENES = {
  villa: {
    img: "/villa-real.jpg",
    aspect: "1264/848",
    names: "aps",
    router: "living",
    dead: ["upper", "master", "pool", "garden"],
    glow: [[52, 55, 60, 45]],
    aps: [
      AP("living", 47, 58, "UniFi U7 Pro", "Wi-Fi 7 · 6 GHz", "1,2 Gbit/s", 14),
      AP("kitchen", 65, 58, "UniFi U7 Pro", "Wi-Fi 7 · 5 GHz", "980 Mbit/s", 8),
      AP("upper", 47, 42, "UniFi U7 Pro", "Wi-Fi 7 · 6 GHz", "1,1 Gbit/s", 6),
      AP("master", 79, 42, "UniFi U7 Pro Wall", "Wi-Fi 7 · 5 GHz", "870 Mbit/s", 5),
      AP("pool", 17, 63, "UniFi U7 Outdoor", "Wi-Fi 7 · 5 GHz", "640 Mbit/s", 4),
      AP("garden", 56, 82, "UniFi U7 Outdoor", "Wi-Fi 7 · 2,4/5 GHz", "520 Mbit/s", 3),
    ],
  },
  chalet: {
    img: "/chalet.jpg",
    aspect: "1684/934",
    names: "aps_chalet",
    router: "lounge",
    dead: ["loft", "terrace", "gym", "garden"],
    glow: [[28, 40, 26, 30], [72, 45, 30, 34], [55, 70, 40, 22]],
    size: [1684, 934],
    sat: {
      sky: [1420, 58],
      dish: [1150, 250],
      tvs: [
        { id: "upper", p: [1020, 360], c: [1060, 290] },
        { id: "living", p: [1240, 480], c: [1215, 370] },
        { id: "left", p: [640, 295], c: [880, 190] },
      ],
    },
    cams: [
      { id: "garage", x: 500, y: 610, dir: 72, spread: 54, len: 340 },
      { id: "corner", x: 1450, y: 420, dir: 135, spread: 46, len: 380 },
      { id: "west", x: 140, y: 360, dir: 60, spread: 48, len: 340 },
    ],
    aps: [
      AP("dining", 26, 47, "UniFi U7 Pro", "Wi-Fi 7 · 6 GHz", "1,2 Gbit/s", 9, [20, 50]),
      AP("loft", 30, 31, "UniFi U7 Pro", "Wi-Fi 7 · 6 GHz", "1,1 Gbit/s", 6, [33, 26]),
      AP("terrace", 78, 40, "UniFi U7 Outdoor", "Wi-Fi 7 · 5 GHz", "760 Mbit/s", 5, [77, 31]),
      AP("lounge", 66, 54, "UniFi U7 Pro", "Wi-Fi 7 · 5 GHz", "980 Mbit/s", 11, [60, 54]),
      AP("gym", 70, 72, "UniFi U7 Pro Wall", "Wi-Fi 7 · 5 GHz", "870 Mbit/s", 4, [76, 76]),
      AP("garden", 38, 80, "UniFi U7 Outdoor", "Wi-Fi 7 · 2,4/5 GHz", "520 Mbit/s", 3, [42, 86]),
    ],
  },
};
